import { fetchAssessmentIntakeForm } from "@/modules/third-party-risk/requests/intake-form-v2";
import { mapV2QuestionsToIntakeQuestions } from "@/modules/third-party-risk/pages/intake-review/utils/map-v2-to-intake-question";
import { addNotification } from "@/shared/states/notification";
import { useEffect, useState } from "react";
import type { IntakeFormQuestion } from "../requests/vendor-intake-form-response";

interface UseIntakeFormQuestionsProps {
  assessmentId: string;
}

export const useIntakeFormQuestions = ({
  assessmentId,
}: UseIntakeFormQuestionsProps) => {
  const [questions, setQuestions] = useState<IntakeFormQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        setIsLoading(true);
        const data = await fetchAssessmentIntakeForm(assessmentId);
        const mapped = mapV2QuestionsToIntakeQuestions(data.questions);
        const visibleQuestions = mapped.filter((q) => !q.hidden_from_user);
        setQuestions(visibleQuestions);
      } catch (error) {
        console.error("Error loading questions:", error);
        addNotification({
          type: "error",
          message: "Failed to load intake form questions",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (assessmentId) {
      void loadQuestions();
    } else {
      setIsLoading(false);
    }
  }, [assessmentId]);

  return {
    questions,
    isLoading,
  };
};
